import { Countries, CountriesWithoutLanguage, Languages } from './countries';
import { FeedTypes, Destinations } from './feed-types';
import { InputMethods } from './input-methods';
import { MtErrorMessages } from './mt-errors';
import { CreateStore } from './create-store';
import { Frequencies } from './frequencies';
import { Days, DayCodes } from './days';
import { Dates } from './dates';
import { Time } from './time';
import { LocalizedTimeZone } from './time-zone';
import { NotificationSettings } from './notification-settings';
import { PromotionTypes, EnhancedPromotionTypes } from './promotion-types';
import { Applicability } from './applicability';
import { OfferTypes } from './offer-types';
import { Status } from './status';
import { CatalogStatusErrors } from './catalog-status-errors';
import { OverallStates } from './overall-states';
import { IssueCodes } from './issue-codes';
import { RejectionReasons } from './rejection-reasons';
import { Currencies } from './currencies';
import { PolicyDescriptions } from './policy-descriptions';
import { GoogleAuthErrorType, GoogleAuthAbbreviatedErrorMessage, GoogleAuthErrorTypeConfigs } from './google-auth-errors';

export const i18nMap = {
  Applicability,
  Countries,
  CountriesWithoutLanguage,
  Currencies,
  Languages,
  FeedTypes,
  Destinations,
  InputMethods,
  MtErrorMessages,
  CreateStore,
  Frequencies,
  Days,
  DayCodes,
  Dates,
  Time,
  LocalizedTimeZone,
  NotificationSettings,
  PromotionTypes,
  EnhancedPromotionTypes,
  GridNoFilteredRecords: _TL_('There are no results available based on your filtered search. Please revise your search.'),
  OfferTypes,
  Status,
  CatalogStatusErrors,
  OverallStates,
  IssueCodes,
  RejectionReasons,
  PolicyDescriptions,
  GoogleAuthErrorType,
  GoogleAuthAbbreviatedErrorMessage,
  GoogleAuthErrorTypeConfigs,
};

export function safeGetString(i18n, map, key, defaultStmt) {
  const englishString = map[key];

  if (!englishString) {
    // TODO: log error to kusto
    if (!defaultStmt) {
      return key;
    }
    return i18n.getString(defaultStmt);
  }

  return i18n.getString(englishString);
}
